export default {
    id: "c78d1fd8-8289-455a-9c47-9d47fbb625ad",
    icon: "mdi-ellipse",
    name: "shapeOval",
    title: "Shape Oval",
    description: "A block oval",
}